export default __webpack_public_path__ + "static/media/TimeReference.790b5a57.md";